import styles from './styles.module.css';

interface ContentItem {
  text: string;
  className?: string;
}

interface ModalContent {
  title: string;
  buttonName: string;
  contents: ContentItem[];
}

const statuses = {
  additionalInsured: 'Active',
  excludedPerson: 'Excluded',
  listOnly: 'List-Only',
  removed: 'Removed',
} as const;

type StatusKey = keyof typeof statuses;

const INFO_TEXT = `If you have any questions about our driver status assignment, please review our <a target='_blank' href='https://resources.clearcover.com/hc/en-us' style='font-size: 16px'>Agent Guidelines</a> in the Agent Resource Center.`;

const startsWithVowel = (str: string) => {
  const lowerCaseStr = str.toLowerCase();
  if (
    lowerCaseStr.startsWith('a') ||
    lowerCaseStr.startsWith('e') ||
    lowerCaseStr.startsWith('i')
  ) {
    return 'an';
  }
  return 'a';
};

export const getModalContent = (
  driverName: string,
  policyHolderTypeValue?: string
): Record<string, ModalContent> => {
  const status = statuses?.[policyHolderTypeValue as StatusKey];
  return {
    additionalInsured: {
      title: `${driverName} cannot be ${startsWithVowel(
        status
      )} ${status} driver.`,
      buttonName: 'Add Driver',
      contents: [
        {
          text: `Based on your answer to these questions, ${driverName} needs to be added to the policy as a standard driver.`,
        },
        {
          text: INFO_TEXT,
        },
      ],
    },
    excludedPerson: {
      title: `${driverName} will be added to the policy as an excluded driver.`,
      buttonName: 'Add Excluded Driver',
      contents: [
        {
          text: `Based on your answer to these questions, ${driverName} needs to be added to the policy as an excluded driver and will not be eligible for coverage if they drive a vehicle listed on this policy.`,
        },
        {
          text: INFO_TEXT,
        },
      ],
    },
    listOnly: {
      title: `${driverName} will be added to the policy as a List-Only driver.`,
      buttonName: 'Add List-Only Driver',
      contents: [
        {
          text: `Based on your answer to these questions, ${driverName} needs to be added to the policy as a List-Only driver.`,
        },
        {
          text:
            'What is a listed driver? Listed drivers have permission to operate the car and are eligible for coverage in case of accidents or other incidents as per the policy terms but do not regularly drive the insured vehicle(s).',
          className: styles.modalContentBold,
        },
        {
          text: INFO_TEXT,
        },
      ],
    },
    removed: {
      title: `${driverName} will be removed from the policy.`,
      buttonName: 'Remove Driver',
      contents: [
        {
          text: `Based on your answer to these questions, ${driverName} will be removed from the policy since they do not live in the household or access the vehicles.`,
        },
        {
          text: INFO_TEXT,
        },
      ],
    },
  };
};
